import { SelectBox } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardHeader, Col, Input, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import QuickActionsModal from '../../components/modals/QuickActionsModal';
import api from '../../services/api-configuration';
import useFormatMessage from '../../utils/useFormatMessage';
import AracBilgileri from './components/AracBilgileri';
import AracHareketleri from './components/AracHareketleri';
import Blokaj from './components/Blokaj';
import Emirler from './components/Emirler';
import GirisCikisTarihleri from './components/GirisCikisTarihleri';
import Hasarlar from './components/Hasarlar';
import SevkiyatHareketleri from './components/SevkiyatHareketleri';
import Tarihce from './components/Tarihce';
import { useAuth } from '../../auth';

const SaseSorgulama = () => {
    const [saseList, setSaseList] = useState([]);
    const { hasRole } = useAuth(11)
    const [allData, setAllData] = useState(null);
    const [vehicleData, setVehicleData] = useState(null);
    const { t } = useFormatMessage();
    const [activeTab, setActiveTab] = useState('1');
    const notifyError = (message) => { toast.error(message) }
    const notiftInfo = (message) => { toast.info(message) }
    const [trigger, setTrigger] = useState(false)
    const [groupage_data, setGroupage_data] = useState([null])
    const [isLoading, setIsLoading] = useState(false);
    const [blockingState, setBlockingState] = useState({
        hasBlokaj: false,
        hasSevkBlokaj: false
    });
    const [isQuickActionsModalOpen, setIsQuickActionsModalOpen] = useState(false);

    const getSase = async (sase, visible) => {
        // Input validation
        if (!sase?.trim()) {
            notifyError(t("Şase numarası boş olamaz."));
            return;
        }

        const trimmedSase = sase.trim();
        if (trimmedSase.length < 6) {
            notifyError(t("Şase numarası en az 6 karakter girilmelidi."));
            return;
        }

        // Set loading state to true when starting API calls
        setIsLoading(true);

        // Clear previous data
        setGroupage_data(null);
        setVehicleData(null);
        setAllData(null);

        let vehicleNotFound = false;

        // Execute vehicle API call first
        try {
            const vehicleResponse = await api.post(
                `/getVehicleByChassisNoNew`,
                { chassis_no: trimmedSase.toUpperCase() }
            );

            if (vehicleResponse?.status === 200) {
                setVehicleData(vehicleResponse.data);
            }
        } catch (error) {
            if (error?.response?.data?.error === 'vehicle not found') {
                notiftInfo("Şase numarası ile araç bulunamadı: " + trimmedSase.toUpperCase());
                vehicleNotFound = true;
                setIsLoading(false);
                return;
            } else if (error?.response?.data?.error?.includes("multiple vehicles found with chassis numbers")) {
                const errorMessage = error.response.data.error;
                const chassisNumbers = errorMessage.split(":").pop().trim().split(", ");
                setSaseList(chassisNumbers);
                notiftInfo(t("Birden fazla şase bulundu"));
                setIsLoading(false);
                return;
            } else {
                let message = error?.response?.data?.error || "";
                notifyError("Hata: " + message);
                setIsLoading(false);
                return;
            }
        }

        // Only continue with other API calls if vehicle is found
        try {
            // Execute other API calls in parallel
            const [groupageResponse, chassisHistoryResponse] = await Promise.all([
                api.post(
                    "/getVehicleStatusHistory",
                    { chassis_no: trimmedSase.toUpperCase() }
                ).catch(error => {
                    if (error?.response?.status === 422) {
                        return { status: 422 };
                    }
                    throw error;
                }),

                api.post(
                    `/getChassisHistory`,
                    { chassis_no: trimmedSase.toUpperCase() }
                )
            ]);

            // Handle groupage response
            if (groupageResponse?.status === 200) {
                setGroupage_data(groupageResponse.data || []);
            } else if (groupageResponse?.status === 422) {
                setGroupage_data([]);
            }

            // Handle chassis history response
            if (chassisHistoryResponse?.status === 200) {
                const data = chassisHistoryResponse?.data?.data ?? {};
                setAllData(data);
            }

        } catch (error) {
            console.error("Error in API calls:", error);
            const errorMessage = error?.response?.data?.error ? error.response.data.error : "Servis hatası";
            const messageParts = errorMessage.split(":");
            messageParts.shift();
            const translatedParts = messageParts.map(part => t(part.trim()));

            if (error?.response?.data?.error?.includes("multiple chassis")) {
                const vehicles = error?.response?.data?.error?.split(":")?.[2]?.split(",") ?? [];
                setSaseList(vehicles);
                notiftInfo(t("Birden fazla şase bulundu"));
            } else {
                notiftInfo(translatedParts.join(": "));
                if (!visible) {
                    setSaseList([]);
                }
            }
        } finally {
            if (!vehicleNotFound) {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        if (document.getElementById("sase-value").value) getSase(document.getElementById("sase-value").value, false)
        // eslint-disable-next-line
    }, [trigger])

    const handleSearch = () => {
        setSaseList([]);
        getSase(document.getElementById("sase-value").value, false);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <>
            <Breadcrumb current={t("Şase Sorgulama")} />
            <Card className='p-4'>
                <CardHeader className='d-flex justify-content-between pb-0'>
                    <Row className='w-100'>
                        <Col lg="10">
                            <div className="dx-field mb-2 w-100 d-flex row">
                                <div className="dx-field-label col-md-3" style={{ color: "black", textAlign: "left", fontWeight: "500" }}>{t("Şase")}</div>
                                <div className="dx-field-value d-flex w-100 col-md-9 px-0">
                                    <Input id="sase-value"
                                        onKeyPress={handleKeyPress} />
                                    <Button
                                        color={isLoading ? "secondary" : "warning"}
                                        className="btn ml-2"
                                        onClick={() => {
                                            setSaseList([]);
                                            getSase(document.getElementById("sase-value").value, false)
                                        }}
                                    >
                                        <i className={`fa ${isLoading ? 'fa-spinner fa-spin' : 'fa-search'}`}></i> &nbsp;{t("Bul")}
                                    </Button>

                                    {
                                        hasRole("sasesorgulama_hizliislemler_write") &&
                                        <Button
                                            color="primary"
                                            disabled={!vehicleData?.chassis_no || !vehicleData?.is_active}
                                            className="btn ml-2 px-2"
                                            onClick={() => setIsQuickActionsModalOpen(true)}
                                        >
                                            {t("Hızlı İşlemler")}
                                        </Button>}

                                </div>
                            </div>

                            <div className="dx-field mb-1 w-100 d-flex row">
                                <div className="dx-field-label col-md-3" style={{ color: "black", textAlign: "left", fontWeight: "500" }}></div>
                                <div className="dx-field-value d-flex w-100 col-md-9 p-0">
                                    {
                                        saseList?.length > 0 &&
                                        <>
                                            <SelectBox
                                                style={{ width: "100%" }}
                                                dataSource={saseList}
                                                onValueChange={(e) => {
                                                    getSase(e, true);
                                                }}
                                                placeholder="Şase Seçiniz"
                                                searchEnabled={true}
                                                searchPlaceholder="Şase Ara"
                                                searchExpr="this"
                                                valueExpr="this"
                                                noDataText={t("No Data")}
                                            />
                                            <Button className="btn btn-warning ml-2" style={{ visibility: "hidden" }}>

                                            </Button>
                                        </>
                                    }

                                </div>
                            </div>

                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col lg="6">
                            <div className="dx-field mb-4 row">
                                <div className="dx-field-label col-md-4" style={{ color: "black", textAlign: "left", fontWeight: "500" }}>{t("Şase")}</div>
                                <div className="dx-field-value col-md-8">
                                    <Input value={vehicleData?.chassis_no || ""} disabled />
                                </div>
                            </div>
                        </Col>
                        <Col lg="6">
                            <div className="dx-field mb-4 row">
                                <div className="dx-field-label col-md-4" style={{ color: "black", textAlign: "left", fontWeight: "500" }}>{t("Marka")}</div>
                                <div className="dx-field-value col-md-8">
                                    <Input value={vehicleData?.brand || ""} disabled />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Nav tabs className="border-tab nav-primary">
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                                    {t("Araç Bilgileri")}
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>
                                    {t("Giriş-Çıkış Tarihleri")}
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => setActiveTab('3')}>
                                    {t("Araç Hareketleri")}
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '4' ? 'active' : ''} onClick={() => setActiveTab('4')}>
                                    {t("Emirler")}
                                </NavLink>
                            </NavItem>

                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '5' ? 'active' : ''} onClick={() => setActiveTab('5')}>
                                    {t("Sevkiyat Hareketleri")}
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '6' ? 'active' : ''} onClick={() => setActiveTab('6')}>
                                    {t("Hasarlar")}
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '7' ? 'active' : ''} onClick={() => setActiveTab('7')}>
                                    {t("Blokaj")}
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                <NavLink className={activeTab === '8' ? 'active' : ''} onClick={() => setActiveTab('8')}>
                                    {t("Tarihçe")}
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Row>
                    <Row className='mt-1'>
                        <TabContent activeTab={activeTab} className="tab-content w-100">
                            <TabPane tabId={"1"}>
                                <AracBilgileri
                                    vehicleData={vehicleData}
                                />
                            </TabPane>

                            <TabPane tabId={"2"}>
                                <GirisCikisTarihleri data={allData?.chassis_operations}
                                    adress_data={allData?.address_operations}
                                />
                            </TabPane>

                            <TabPane tabId={"3"}>
                                <AracHareketleri data={allData?.address_operations} />
                            </TabPane>

                            <TabPane tabId={"4"}>
                                <Emirler data={allData?.chassis_operations}
                                />
                            </TabPane>

                            <TabPane tabId={"5"}>
                                <SevkiyatHareketleri
                                    groupage_data={groupage_data}
                                />
                            </TabPane>

                            <TabPane tabId={"6"}>
                                <Hasarlar trigger={trigger} setTrigger={setTrigger}
                                    data={allData?.damage_records}
                                />
                            </TabPane>

                            <TabPane tabId={"7"}>
                                <Blokaj
                                    data={allData?.chassis_operations}
                                    blockingState={blockingState}
                                    setBlockingState={setBlockingState}
                                />
                            </TabPane>

                            <TabPane tabId={"8"}>
                                <Tarihce
                                    data={allData?.chassis_operations || []}
                                    datas={JSON.stringify(allData?.chassis_operations || [])}
                                />
                            </TabPane>

                        </TabContent>
                    </Row>
                </CardBody>
            </Card>

            <QuickActionsModal
                isOpen={isQuickActionsModalOpen}
                onClose={() => setIsQuickActionsModalOpen(false)}
                chassisNo={vehicleData?.chassis_no}
                onActionSuccess={() => {
                    if (vehicleData?.chassis_no) {
                        getSase(vehicleData.chassis_no, false);
                    }
                }}
            />
        </>
    )
}

export default SaseSorgulama
